import React, { useEffect, useState } from "react";
import AddEditRegistrationFee from "./add-edit-registration-fee/add-edit-registration-fee";
import appStyles from "../../app.module.css";
import Api from "../classes/api";
import AppConstants from "../classes/constants";
import AppUtil from "../classes/util";

const RegistrationFees = () => {
  const [registrationFees, setRegistrationFees] = useState([]);
  const [selectedFee, setSelectedFee] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setError(null);
  }, [selectedFee]);

  useEffect(() => {
    loadRegistrationFees();
  }, []);

  const loadRegistrationFees = async () => {
    try {
      setError(null);
      const formData = new FormData();
      formData.append("action", "rsquote_registration_fee");
      formData.append("method", AppConstants.WP_METHOD.LIST);
      const apiSvc = await Api.getInstance();
      const res = await apiSvc.getData(formData);
      setRegistrationFees(res.data?.data?.length ? res.data.data : []);
    } catch (err) {
      setError(AppUtil.getErrorMessage(err));
    }
  };

  const handleClose = () => {
    setSelectedFee(null);
  };

  const handleSubmit = async (values) => {
    try {
      setError(null);
      const formData = new FormData();
      if (selectedFee?.id) {
        formData.append("id", selectedFee.id);
      }
      formData.append("min_price", values.min_price || 0);
      formData.append("max_price", values.max_price || null);
      formData.append("buyer_fee", values.buyer_fee || 0);
      formData.append("action", "rsquote_registration_fee");
      formData.append(
        "method",
        selectedFee?.id
          ? AppConstants.WP_METHOD.EDIT
          : AppConstants.WP_METHOD.NEW
      );
      const apiSvc = await Api.getInstance();
      const res = await apiSvc.addEditDeleteRequest(formData);
      if (res?.data?.success) {
        setSelectedFee(null);
        loadRegistrationFees();
      } else {
        setError(AppUtil.getErrorMessage(res));
      }
    } catch (err) {
      setError(AppUtil.getErrorMessage(err));
    }
  };

  const handleDalete = async (id) => {
    try {
      setError(null);
      const formData = new FormData();
      formData.append("id", id);
      formData.append("action", "rsquote_registration_fee");
      formData.append("method", AppConstants.WP_METHOD.DELETE);
      const apiSvc = await Api.getInstance();
      const res = await apiSvc.addEditDeleteRequest(formData);
      if (res?.data?.success) {
        loadRegistrationFees();
      } else {
        setError(AppUtil.getErrorMessage(res));
      }
    } catch (err) {
      setError(AppUtil.getErrorMessage(err));
    }
  };

  return (
    <div className={appStyles.rezziBlock}>
      <div className={appStyles.rezziBlockHeader}>
        <h2 className={appStyles.colorPrimary}> Registration Fees </h2>
        <button onClick={() => setSelectedFee({})}>Add New</button>
      </div>
      {!selectedFee && error && (
        <div className={appStyles.colorDanger}>{error}</div>
      )}
      <div className={appStyles.rezziBlockHeaderTable}>
        <table width="100%" cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}>
                Minimum Price
              </th>
              <th className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}>
                Maximum Price
              </th>
              <th className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}>
                Buyer Fee
              </th>
              <th
                className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
              ></th>
            </tr>
          </thead>
          <tbody>
            {registrationFees?.length
              ? registrationFees.map((registrationFee) => {
                  return (
                    <tr key={registrationFee.id}>
                      <td>{registrationFee.min_price}</td>
                      <td>{registrationFee.max_price}</td>
                      <td>{registrationFee.buyer_fee}</td>
                      <td className={appStyles.textRight}>
                        <button onClick={() => setSelectedFee(registrationFee)}>
                          Edit
                        </button>
                        <button
                          className={appStyles.buttonOutline}
                          onClick={() => handleDalete(registrationFee.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </table>
      </div>
      {selectedFee && (
        <AddEditRegistrationFee
          registrationFees={registrationFees}
          registrationFee={selectedFee}
          submit={handleSubmit}
          close={handleClose}
          error={error}
        />
      )}
    </div>
  );
};

export default RegistrationFees;
